import { render, staticRenderFns } from "./OngoingUserTasks.vue?vue&type=template&id=1dce3e00"
import script from "./OngoingUserTasks.vue?vue&type=script&lang=ts"
export * from "./OngoingUserTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports